var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_2132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.5C24.5 5.87262 19.1274 0.5 12.5 0.5C5.87262 0.5 0.5 5.87262 0.5 12.5C0.5 18.4895 4.88825 23.454 10.625 24.3542V15.9688H7.57812V12.5H10.625V9.85625C10.625 6.84875 12.4166 5.1875 15.1576 5.1875C16.4705 5.1875 17.8438 5.42188 17.8438 5.42188V8.375H16.3306C14.8399 8.375 14.375 9.30003 14.375 10.2491V12.5H17.7031L17.1711 15.9688H14.375V24.3542C20.1117 23.454 24.5 18.4896 24.5 12.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1711 15.9688L17.7031 12.5H14.375V10.2491C14.375 9.29994 14.8399 8.375 16.3306 8.375H17.8438V5.42188C17.8438 5.42188 16.4705 5.1875 15.1575 5.1875C12.4166 5.1875 10.625 6.84875 10.625 9.85625V12.5H7.57812V15.9688H10.625V24.3542C11.2453 24.4514 11.8722 24.5001 12.5 24.5C13.1278 24.5001 13.7547 24.4514 14.375 24.3542V15.9688H17.1711Z",
    fill: "#F7F9FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_2132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c3207852f2420fd3510b6ea669af7db3.svg";
export { ForwardRef as ReactComponent };